import type { Meta, StoryFn } from '@storybook/react';

import { DateTimeDisplay, DurationDisplay } from '@pega/cosmos-react-core';
import type { DateTimeDisplayProps, DurationDisplayProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/DateTime'
} as Meta;

export const DurationDisplayDemo: StoryFn<DurationDisplayProps> = (args: DurationDisplayProps) => {
  return (
    <DurationDisplay
      value={args.value}
      significantUnits={args.significantUnits}
      unitDisplay={args.unitDisplay}
      maxPrecision={args.maxPrecision}
    />
  );
};

DurationDisplayDemo.args = {
  value: 462553844,
  significantUnits: 5,
  unitDisplay: undefined,
  maxPrecision: undefined
};

DurationDisplayDemo.argTypes = {
  value: { control: { type: 'number' } },
  significantUnits: { options: [1, 2, 3, 4, 5], control: { type: 'select' } },
  unitDisplay: { options: [undefined, 'narrow', 'short', 'long'], control: { type: 'select' } },
  maxPrecision: {
    options: [undefined, 'day', 'hour', 'minute', 'second', 'millisecond'],
    control: { type: 'select' }
  }
};

export const DateTimeDisplayDemo: StoryFn<DateTimeDisplayProps> = (args: DateTimeDisplayProps) => {
  return (
    <DateTimeDisplay
      value={args.value}
      variant={args.variant}
      format={args.format}
      clockFormat={args.clockFormat}
    />
  );
};

DateTimeDisplayDemo.args = {
  value: new Date(),
  variant: 'date',
  format: 'short',
  clockFormat: undefined
};

DateTimeDisplayDemo.argTypes = {
  value: { control: { type: 'date' } },
  variant: {
    options: [
      'date',
      'datetime',
      'time',
      'week',
      'month',
      'year',
      'monthyear',
      'quarteryear',
      'relative'
    ],
    control: { type: 'select' }
  },
  format: { options: ['short', 'medium', 'long', 'numeric'], control: { type: 'select' } },
  clockFormat: {
    options: [undefined, 12, 24],
    control: { type: 'inline-radio' }
  }
};
